<template>
  <div>
    <div class="flex mt-2" v-for="(item, i) in legendData" :key="i">
      <div class="h-4 w-4 mr-6 my-4">
        <img :src="item.icon" />
      </div>
      <sp class="w-full text-left pt-2">{{ item.title }}</sp>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

import BlueBlack from '@/assets/icons/default-l-00b7ff.svg';
import GreenBlack from '@/assets/icons/default-l-8dc114.svg';
import BlueStar from '@/assets/icons/star-l-00b7ff.svg';
import GreenStar from '@/assets/icons/star-l-8dc114.svg';
import sp from '@/components/atoms/s-p-small.vue';

export default {
  name: 'InfoLegend',
  components: {
    sp,
  },
  setup() {
    const legendData = ref([
      {
        icon: BlueBlack,
        title: 'Accepts Paint and other Household Hazardous Waste (HHW).',
      },
      {
        icon: GreenBlack,
        title: 'Accepts Paint Only.',
      },
      {
        icon: BlueStar,
        title: 'Accepts Paint and other HWW; also has a Reuse Program',
      },
      {
        icon: GreenStar,
        title: 'Accepts Paint only; also has a Reuse Program',
      },
    ]);

    return {
      legendData,
    };
  },
};
</script>
